import { EntityModel } from '@/interfaces'
import {
  ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY,
  CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
  DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
  FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
  SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY,
  UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
} from './graphql'
import cmsTextWithImageBlockEntity from '@/entities/cmsTextWithImageBlock/entity'

const cmsContentBlockAssignmentModel: EntityModel = {
  name: 'contentBlockAssignment',
  namePlural: 'contentBlockAssignments',
  uniqueName: 'cmsContentBlockAssignment',
  uniqueNamePlural: 'cmsContentBlockAssignments',
  path: 'cms/blocks/content_block_assignment',
  baseUrl: '/cms/blocks/content_block_assignments',
  translationPrefix: 'entities:cmsContentBlockAssignment.',
  getDisplayName: (values: any) => {
    return 'Content Block Assignment'
  },
  gql: {
    getAll: ALL_CONTENT_BLOCK_ASSIGNMENTS_QUERY,
    getSingle: SINGLE_CONTENT_BLOCK_ASSIGNMENT_QUERY,
    create: CREATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
    update: UPDATE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
    delete: DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
    forceDelete: FORCE_DELETE_CONTENT_BLOCK_ASSIGNMENT_MUTATION,
  },
  attributes: {
    type: {
      name: 'type',
      label: 'entities:cmsContentBlockAssignment.attributes.type.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'select',
      selectOptions: [
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.GRID.label',
          value: 'GRID',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.BACKGROUND.label',
          value: 'BACKGROUND',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.PAGE_HEADER.label',
          value: 'PAGE_HEADER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.IMAGE.label',
          value: 'IMAGE',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.SLIDER.label',
          value: 'SLIDER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.HEADING.label',
          value: 'HEADING',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT.label',
          value: 'TEXT',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.WYSIWYG.label',
          value: 'WYSIWYG',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT_WITH_IMAGE.label',
          value: 'TEXT_WITH_IMAGE',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TEXT_WITH_ICON.label',
          value: 'TEXT_WITH_ICON',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.ACCORDION.label',
          value: 'ACCORDION',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.BUTTON.label',
          value: 'BUTTON',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.DIVIDER.label',
          value: 'DIVIDER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.IFRAME.label',
          value: 'IFRAME',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.HEADER_SLIDER.label',
          value: 'HEADER_SLIDER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.BESTSELLER_SLIDER.label',
          value: 'BESTSELLER_SLIDER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.DESTINATIONS.label',
          value: 'DESTINATIONS',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_GUIDES.label',
          value: 'TRAVEL_GUIDES',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.EMPLOYEES.label',
          value: 'EMPLOYEES',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.CONTACT_BANNER.label',
          value: 'CONTACT_BANNER',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.FORM.label',
          value: 'FORM',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.NEWSLETTER_REGISTRATION.label',
          value: 'NEWSLETTER_REGISTRATION',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.ISSUU_CATALOG.label',
          value: 'ISSUU_CATALOG',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.FILTER_LEAD_FORM.label',
          value: 'FILTER_LEAD_FORM',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.PREFILTERED_TRAVELS.label',
          value: 'PREFILTERED_TRAVELS',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_SELECTION.label',
          value: 'TRAVEL_SELECTION',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.TRAVEL_TYPES.label',
          value: 'TRAVEL_TYPES',
        },
        {
          label: 'entities:cmsContentBlockAssignment.attributes.type.selectOptions.BUSFINDER_WIDGET.label',
          value: 'BUSFINDER_WIDGET',
        },
      ],
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    block: {
      name: 'block',
      label: 'entities:cmsContentBlockAssignment.attributes.block.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return cmsTextWithImageBlockEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsContentBlockAssignmentModel
